import { ProtectedRouteLoadingFallback } from "@/components/routing/RouteLoadingFallback";

interface AuthResolveSkeletonProps {
  message?: string;
}

/** Skeleton shell shown while auth/session checks resolve (replaces full-page spinner). */
export function AuthResolveSkeleton({
  message = "Verifying your account...",
}: Readonly<AuthResolveSkeletonProps>) {
  return (
    <div aria-busy="true" aria-label={message}>
      <span className="sr-only">{message}</span>
      <ProtectedRouteLoadingFallback />
    </div>
  );
}
